import { ReactNode } from "react";
import { IlustracionVacia } from "./IlustracionVacia";

export function EmptyState({
  titulo,
  descripcion,
  accion,
  compacto = false,
}: {
  titulo: string;
  descripcion?: string;
  accion?: ReactNode;
  // Versión más chica para usarse dentro de tarjetas pequeñas (ej. las
  // mini-tarjetas del Dashboard), donde el tamaño normal (pensado para una
  // página vacía completa) se vería demasiado grande.
  compacto?: boolean;
}) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 text-center ${compacto ? "py-6" : "py-16"}`}>
      <div className="rounded-full bg-brand-50 p-3">
        <IlustracionVacia className={compacto ? "h-14 w-14" : "h-20 w-20"} />
      </div>
      <p className="text-sm font-medium text-slate-700">{titulo}</p>
      {descripcion && <p className="max-w-sm text-sm text-slate-400">{descripcion}</p>}
      {accion}
    </div>
  );
}
